import Vue from "vue";
import Router from "vue-router";
import i18n from "@/_helpers/i18n";
import { store } from "@/_store";

// Import views
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Agencies from "../views/Agencies.vue";
import ClientSubscriptions from "../views/ClientSubscriptions.vue";
import ClientSubscribers from "@/components/Agencies/ClientSubscribers.vue";
import AgencyContract from "../components/Agencies/AgencyContract.vue";
import ImportError from "../components/Targets/importError.vue";
import LostPassword from "../views/LostPassword.vue";
import AllOpportunities from "@/components/Opportunities/AllOpportunities.vue";
import Emails from "../views/Emails.vue";
import AntispamAudit from "../components/Emails/AntispamAudit.vue";
import Users from "../views/Users.vue";
import Statistics from "../views/Statistics.vue";
import Campaigns from "../views/Campaigns.vue";
import Billing from "../views/Billing.vue";
import SettingsAccount from "../views/SettingsAccount.vue";
import Dashboard from "../views/Dashboard.vue";
import DashboardFirst from "../views/Dashboard.vue";
import Upgrade from "../views/Upgrade.vue";
import Downgrade from "../views/Downgrade.vue";
import CreateAccount from "../views/CreateAccount.vue";
import CreateBookerAccount from "../views/CreateBookerAccount.vue";
import CampaignProblems from "../views/CampaignProblems.vue";
import Calendars from "../views/Calendars.vue";
import MyCalendar from "../views/MyCalendar.vue";
import Businesses from "../views/Businesses.vue";
import Activity from "../views/Activity.vue";
import AccountDeleted from "../views/AccountDeleted.vue";
import Companies from "../views/Companies.vue";
import faq from "../views/faq.vue";
import tutorials from "../views/tutorials.vue";
import checklist from "../views/Checklist.vue";
import improvement from "../views/improvement.vue";
import AdminSystemChat from "../views/AdminSystemChat.vue";
import ImportLinkedinContacts from "@/components/Contacts/ImportLinkedinContacts.vue";
import SyncEmails from "@/components/SyncEmails/SyncEmails.vue";
import AllPerformances from "@/components/Performances/AllPerformances.vue";
import AllInfrastructure from "@/components/Infrastructure/AllInfrastructure.vue";
import AllBDR from "@/components/BDR/AllBDR.vue";
import OliverSalesStats from "@/components/Performances/OliverSalesStats.vue";
import OliverSalesDashboard from "@/components/Performances/OliverSalesDashboard.vue";
import OnDemandView from "@/components/Contacts/OnDemandView.vue";
import MyContactsList from "@/views/MyContactsList.vue";
import SelectedUser from "@/components/Users/SelectedUser.vue";
import Campaigndashboard from "../views/Campaigndashboard.vue";
import EmailView from "@/components/Emails/EmailView.vue";
import CampaignDashboard from "@/components/Campaigns/CampaignDashboard.vue";
import YourAudience from "@/components/AccountCreation/Steps/Campaign/YourAudience.vue";
import YourMessage from "@/components/AccountCreation/Steps/Campaign/YourMessage.vue";
import Tracking from "@/components/AccountCreation/Steps/Campaign/Tracking.vue";
import Budget from "@/components/AccountCreation/Steps/Campaign/Budget.vue";
import Summary from "@/components/AccountCreation/Steps/Campaign/Summary.vue";
import Connection from "@/components/AccountCreation/Steps/Campaign/Connection.vue";
import CampaignEdit from "@/components/AccountCreation/Steps/CampaignEdit.vue";
import SelectedContact from "@/components/Businesses/SelectedContact.vue";
import SelectedCompany from "@/components/Businesses/SelectedCompany.vue";
import MonthlyReport from "@/components/Reports/MonthlyReport.vue";
import Usages from "../views/Usages.vue";
import InvoicesRecovering from "../components/Billing/InvoiceRecovering.vue";
import NylasCalendar from "../components/Account/NylasCalendar.vue";
import Onboarding from "../views/Onboarding.vue";
import Orders from "@/components/Onboarding/Orders.vue";
import Order from "@/views/Order.vue";
import Promotion from "@/views/Promotion.vue";
import Payment from "@/views/Payment.vue";
import ClientServiceProporsal from "@/views/ClientServiceProporsal.vue";
import ClientServiceProporsalConfirmation from "@/views/ClientServiceProporsalConfirmation.vue";
import MyTeam from "@/views/Team.vue";
import TeamsGlobal from "@/components/Team/TeamsGlobal.vue";
import CalendarConfig from "@/views/CalendarConfig.vue";
import AdminTasksPage from "@/components/Opportunities/SingleOpportunity/AdminTasksPage.vue";
import BusinessInfo from "@/components/Businesses/BusinessInfo.vue";
import OrdersWarning from "@/components/Targets/OrdersWarnings.vue";
import BookerDailyReport from "../components/BDR/BookerDailyReport.vue";
import SmartleadEmailsStats from "../components/Configuration/SmartleadEmailsStats.vue";
import DataMonitoringStats from "../components/Configuration/DataMonitoringStats.vue";

import jQuery from "jquery";
import { optionsList } from "../_store/optionsList.module";
import BookersCalls from "../components/BDR/BookersCalls.vue";
import BookerCommission from "../components/BDR/BookerCommission.vue";
import BookerMerciHubert from "../components/BDR/BookerMerciHubert.vue";
import BookerOnboarding from "../components/BDR/BookerOnboarding.vue";
import BdrClients from "../components/BDR/BdrClients.vue";
import MicrosoftLicences from "../components/Configuration/MicrosoftLicences.vue";
import BlackList from "../components/Account/BlackList.vue";
import Affiliation from "../views/Affiliation.vue";
import bookerAcademy from "../components/BDR/bookerAcademy.vue";
import BookerTestCall from "../components/BDR/BookerTestCall.vue";
import MeetingAttendanceStatus from "../components/Opportunities/MeetingAttendanceStatus.vue";
import AttendanceStats from "../components/Opportunities/AttendanceStats.vue";
import MeetingsStatusProcessed from "../components/Opportunities/MeetingsStatusProcessed.vue";
import LinkClaims from "../components/Opportunities/LinkClaims.vue";
import Invoices from "@/components/Billing/Invoices.vue";
import ClientStats from "@/components/Reports/ClientStats.vue";
import ClientLaunchings from "../components/Reports/ClientLaunchings.vue";
import ClientDocs from "../components/Reports/ClientDocs.vue";
import PaymentMethodsList from "../components/Billing/PaymentMethodsList.vue";
import CreditNoteList from "../components/Billing/CreditNoteList.vue";
import BookerDashboard from "../components/BDR/BookerDashboard.vue";
import ClientPlaybook from "../components/Agencies/ClientPlaybook.vue";
import AIMeetingsReplay from "../components/Agencies/AIMeetingsReplay.vue";
import BillingClientSpace from "../components/Billing/BillingClientSpace.vue";
import { is } from "core-js/core/object";

let $ = jQuery;

Vue.use(Router);

export const router = new Router({
  linkActiveClass: "active",
  mode: "history",
  duplicateNavigationPolicy: "ignore",
  routes: [
    {
      path: "/nylas",
      name: "nylas",
      component: NylasCalendar,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "Login",
      },
    },
    {
      path: "/lostpassword",
      name: "lostpassword",
      component: LostPassword,
    },
    {
      path: "/deleted",
      name: "deleted",
      component: AccountDeleted,
      meta: {
        rolAuth: ["2", "3"],
      },
    },
    {
      path: "/proposal",
      name: "proposal",
      component: AgencyContract,
    },
    {
      path: "/client-service-proposal/:clientId",
      name: "client-service-proposal",
      component: ClientServiceProporsal,
      beforeEnter: (to, from, next) => {
        store.dispatch("optionsList/getAll").then(() => {
          next();
        });
      },
    },
    {
      path: "/client-service-proposal-action/:action?/:detail?",
      name: "client-service-proposal-action",
      component: ClientServiceProporsalConfirmation,
    },
    {
      path: "/mycalendar/:account_id?/:business_contact_hash?/:campaign_hash?",
      name: "mycalendar",
      component: MyCalendar,
    },
    {
      path: "/payment/:form?",
      name: "payment",
      component: Payment,
    },
    {
      path: "/createaccount",
      name: "createaccount",
      component: CreateAccount,

      children: [
        {
          path: "/createaccount/:referred?",
          name: "createaccount",
          props: { referred: true },
          component: CreateAccount,
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getAll").then(() => {
              next();
            });
          },
        },
      ],
    },
    {
      path: "/bookerregistration",
      name: "createbooker",
      component: CreateBookerAccount,
      beforeEnter: (to, from, next) => {
        Promise.all([
          store.dispatch("optionsList/getProfileCountries"),
          store.dispatch("optionsList/getLanguages"),
        ])
          .then(() => {
            next();
          })
          .catch(() => next(false));
      },
    },
    {
      path: "/bookerregistration/referrer/:referrer_id",
      name: "createbooker",
      component: CreateBookerAccount,
      beforeEnter: (to, from, next) => {
        Promise.all([
          store.dispatch("optionsList/getProfileCountries"),
          store.dispatch("optionsList/getLanguages"),
        ])
          .then(() => {
            next();
          })
          .catch(() => next(false));
      },
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        keepAlive: true, // Need to be cached
      },
      children: [
        {
          path: "/clients/:id?",
          name: "clients",
          component: Agencies,
          meta: {
            rolAuth: ["1", "2", "5", "6", "7", "8"],
            KeepAlive: true, // Need to be cached
            title: i18n.t("lang.label.clients"),
          },
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getAll").then(() => {
              next();
            });
          },
        },
        {
          path: "/client-subscriptions/:id?",
          name: "client-subscriptions",
          component: ClientSubscriptions,
          meta: {
            rolAuth: ["1", "5", "6", "7", "8"],
            KeepAlive: true, // Need to be cached
            title: "Client Subscriptions",
          },
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getAll").then(() => {
              next();
            });
          },
        },
        {
          path: "/client-subscribers",
          name: "client-subscribers",
          component: ClientSubscribers,
          meta: {
            rolAuth: ["1", "5", "6", "7", "8"],
            KeepAlive: true, // Need to be cached
            //title: "Suscribers",
          },
        },
        {
          path: "/client-stats",
          name: "client-stats",
          component: ClientStats,
          meta: {
            rolAuth: ["1"],
            title: "Client Stats",
          },
        },
        {
          path: "/client-launchings",
          name: "client-launchings",
          component: ClientLaunchings,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
            title: "Client Launchings",
          },
        },
        {
          path: "/client-docs",
          name: "client-docs",
          component: ClientDocs,
          meta: {
            rolAuth: ["1", "4"],
            title: "Client Docs",
          },
        },
        {
          path: "/client-space",
          name: "client-space",
          component: BillingClientSpace,
          meta: {
            rolAuth: ["3", "4"],
            title: "Client Space",
          }, 
        },
        {
          path: "/businesscontact/:id?",
          name: "business",
          component: BusinessInfo,
          meta: {
            rolAuth: ["1", "5", "6", "7", "8"],
            KeepAlive: true, // Need to be cached
          },
        },
        {
          path: "/contract",
          name: "contract",
          component: AgencyContract,
          meta: {
            rolAuth: ["1", "4"],
            KeepAlive: true, // Need to be cached
          },
        },
        {
          path: "/my_team",
          name: "my_team",
          component: MyTeam,
          meta: {
            rolAuth: ["3", "4"],
          },
        },
        {
          path: "/calendar_config",
          name: "calendar_config",
          component: CalendarConfig,
          meta: {
            rolAuth: ["3", "4"],
          },
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getTimezones").then(() => {
              next();
            });
          },
        },
        {
          path: "/blacklist",
          name: "blacklist",
          component: BlackList,
          meta: {
            rolAuth: ["3", "4"],
          },
        },
        {
          path: "/playbook",
          name: "playbook",
          component: ClientPlaybook,
          meta: {
            rolAuth: ["3", "4"],
          },
        },
        {
          path: "/ai-meetings-replay",
          name: "ai-meetings-replay",
          component: AIMeetingsReplay,
          meta: {
            rolAuth: ["1", "3", "4"],
          },
        },
        {
          path: "/upgrade",
          name: "upgrade",
          component: Upgrade,
          meta: {
            rolAuth: ["1", "2", "4"],
            title: i18n.t("lang.button.upgrade"),
          },
        },
        {
          path: "/downgrade/:id?",
          name: "downgrade",
          component: Downgrade,
          meta: {
            rolAuth: ["1", "2", "4"],
          },
        },
        {
          path: "/statistics",
          name: "statistics",
          component: Statistics,
          meta: {
            rolAuth: ["1", "4"],
          },
        },
        {
          path: "/mysearchs",
          name: "mysearchs",
          component: ImportLinkedinContacts,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },

        {
          path: "/microsoftlicences",
          name: "microsoftlicences",
          component: MicrosoftLicences,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/smartleadstats",
          name: "smartleadstats",
          component: SmartleadEmailsStats,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/data-monitoring-stats",
          name: "data-monitoring-stats",
          component: DataMonitoringStats,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/import-error",
          name: "import-error",
          component: ImportError,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/syncemails/:item/:status?",
          name: "syncemails",
          component: SyncEmails,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/allperformances/:item",
          name: "allperformances",
          component: AllPerformances,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/allinfrastructure/:item",
          name: "allinfrastructure",
          component: AllInfrastructure,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/allbdr/:item",
          name: "allbdr",
          component: AllBDR,
          meta: {
            rolAuth: ["1", "2", "5", "6", "8", "9"],
          },
        },
        {
          path: "/bookers-calls",
          name: "bookers-calls",
          component: BookersCalls,
          meta: {
            rolAuth: ["1", "2", "5", "6", "8", "9"],
          },
        },
        {
          path: "/booker-commission",
          name: "booker-commission",
          component: BookerCommission,
          meta: {
            rolAuth: ["1", "2", "5", "6", "8", "9"],
          },
        },
        {
          path: "/oliver_sales_stats",
          name: "oliver_sales_stats",
          component: OliverSalesStats,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/oliver_sales_dashboard/:item",
          name: "oliver_sales_dashboard",
          component: OliverSalesDashboard,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/team-global-view",
          name: "team-global-view",
          component: TeamsGlobal,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
            title: "Teams — Global view",
          },
        },
        {
          path: "/orders_warnings/:item",
          name: "orders_warnings",
          component: OrdersWarning,
          meta: {
            rolAuth: ["1", "5", "6", "8"],
          },
        },
        {
          path: "/calendars",
          name: "calendars",
          component: Calendars,
          meta: {
            rolAuth: ["1", "5", "6"],
            title: "Calendars",
          },
        },
        {
          path: "/checklist",
          name: "checklist",
          component: checklist,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        {
          path: "/mysearchs/:defaulttab",
          props: { defaulttab: "newsearch" },
          name: "mysearchs",
          component: ImportLinkedinContacts,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        {
          path: "/ondemand",
          name: "ondemand",
          component: OnDemandView,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        {
          path: "/admin-tasks",
          name: "admin-tasks",
          component: AdminTasksPage,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6", "7", "8"],
          },
        },
        {
          path: "/daily-reports",
          name: "daily-reports",
          component: BookerDailyReport,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6", "7", "8"],
          },
        },
        {
          path: "/Affiliation",
          name: "affiliations",
          component: Affiliation,
          meta: {
            rolAuth: ["1", "5", "7"],
            afterTrialPeriodAvailable: false,
            KeepAlive: true, // Need to be cached
            title: "Affiliates Comissions",
            restrictConstraint2: true,
          },
        },

        {
          path: "/opportunities",
          name: "opportunities",
          component: AllOpportunities,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6", "7"],
            afterTrialPeriodAvailable: false,
            KeepAlive: true, // Need to be cached
            title: i18n.t("lang.menu.opportunities"),
          },
        },
        {
          path: "/opportunities/:id",
          name: "opportunity",
          component: AllOpportunities,
          props: { id: true },
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6", "7", "9"],
            afterTrialPeriodAvailable: false,
            title: i18n.t("lang.menu.opportunities"),
          },
        },
        {
          path: "/emails/:id?",
          name: "emails",
          component: Emails,
          meta: {
            rolAuth: ["1", "2", "8"],
            title: i18n.t("lang.label.emails"),
          },
          children: [
            {
              path: "/emails/:id",
              component: EmailView,
              props: { id: true },
              meta: {
                rolAuth: ["1", "2", "8"],
              },
            },
          ],
        },
        {
          path: "/emailscat/:cat?",
          name: "emails",
          component: Emails,
          meta: {
            rolAuth: ["1", "2", "8"],
            title: i18n.t("lang.label.emails"),
          },
        },
        {
          path: "/antispam-audit",
          name: "antispam-audit",
          component: AntispamAudit,
          meta: {
            rolAuth: ["1", "8"],
            title: "Audit captcha Mailinblack",
          },
        },
        {
          path: "/businesses/:id?",
          name: "businesses",
          component: Businesses,
          meta: {
            rolAuth: ["1", "2", "3", "4"],
            afterTrialPeriodAvailable: false,
            KeepAlive: true, // Need to be cached
          },
          children: [
            {
              path: "/contact/:id",
              name: "selected-contact",
              component: SelectedContact,
              props: { id: true, business_id: true },
              meta: {
                rolAuth: ["1", "2"],
              },
            },
            {
              path: "/company/:id",
              component: SelectedCompany,
              name: "selected-company",
              props: { id: true, contact_id: true },
              meta: {
                rolAuth: ["1", "2"],
                title: i18n.t("lang.menu.companies"),
              },
            },
          ],
        },
        {
          path: "/companies/:id?",
          name: "companies",
          component: Companies,
          meta: {
            rolAuth: ["1", "2"],
            title: i18n.t("lang.menu.companies"),
          },
        },
        {
          path: "/mycontacts",
          name: "mycontacts",
          component: MyContactsList,
          meta: {
            rolAuth: ["1", "2", "3", "4"],
          },
        },
        {
          path: "/activity",
          name: "activity",
          component: Activity,
          meta: {
            rolAuth: ["1", "2", "3", "4"],
            title: i18n.t("lang.menu.activity"),
          },
        },
        {
          path: "/meeting-attendance",
          name: "meeting-attendance",
          component: MeetingAttendanceStatus,
          meta: {
            rolAuth: ["1", "2"],
            title: i18n.t("lang.menu.meeting_status"),
          },
        },
        {
          path: "/attendance-stats",
          name: "attendance-stats",
          component: AttendanceStats, // MeetingAttendanceStatus,
          meta: {
            rolAuth: ["1"],
            title: i18n.t("lang.menu.meeting_status"),
          },
        },
        {
          path: "/meetings-status-processed",
          name: "meetings-status-processed",
          component: MeetingsStatusProcessed,
          meta: {
            rolAuth: ["1"],
            title: i18n.t("lang.column.meeting_status"),
          },
        },
        {
          path: "/link-claims",
          name: "link-claims",
          component: LinkClaims,
          meta: {
            rolAuth: ["1"],
            title: i18n.t("lang.menu.claims"),
          },
        },
        {
          path: "/users/:id?",
          name: "users",
          component: Users,
          meta: {
            rolAuth: ["1", "5", "6"],
          },
          children: [
            {
              path: "/users/:id",
              component: SelectedUser,
              props: { id: true },
              meta: {
                rolAuth: ["1", "5", "6"],
              },
            },
          ],
        },
        {
          path: "/dashboard/:id?",
          name: "dashboard",
          component: Dashboard,
          meta: {
            rolAuth: ["1", "2", "3", "5", "6", "7", "8"],
            KeepAlive: true, // Need to be cached
            title: i18n.t("lang.menu.dashboard"),
          },
        },
        {
          path: "/dashboard/tabs/:tab?",
          name: "dashboard",
          component: Dashboard,
          meta: {
            rolAuth: ["1", "2", "3", "5", "6", "7", "8"],
            KeepAlive: true, // Need to be cached
            title: i18n.t("lang.menu.dashboard"),
          },
        },
        {
          path: "/dashboardfirst",
          name: "dashboardfirst",
          component: DashboardFirst,
          meta: {
            rolAuth: ["1", "2", "3", "8"],
            keepAlive: true, // Need to be cached
            title: i18n.t("lang.menu.dashboard"),
          },
        },
        {
          path: "/campaigndashboard",
          name: "campaigndashboard",
          component: Campaigndashboard,
          meta: {
            rolAuth: ["1", "2", "3"],
            KeepAlive: false, // Need to be cached
            title: i18n.t("lang.menu.campaigns"),
          },
        },
        {
          path: "/faq",
          name: "faq",
          component: faq,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        // {
        //   path: "/merci-hubert/test-llamada",
        //   name: "merci-hubert-test-llamada",
        //   component: BookerTestCall,
        //   meta: {
        //     rolAuth: ["2"],
        //   },
        // },
        {
          path: "/merci-hubert",
          name: "merci-hubert",
          component: BookerTestCall,
          meta: {
            rolAuth: ["2"],
          },
        },
        {
          path: "/booker-dashboard",
          name: "booker-dashboard",
          component: BookerDashboard,
          meta: {
            rolAuth: ["2"],
          },
        },
        {
          path: "/booker-onboarding",
          name: "booker-onboarding",
          component: BookerOnboarding,
          meta: {
            rolAuth: ["2"],
          },
        },
        {
          path: "/academy",
          name: "booker-academy",
          component: bookerAcademy,
          meta: {
            rolAuth: ["2"],
          },
        },
        {
          path: "/booker-clients",
          name: "booker-clients",
          component: BdrClients,
          meta: {
            rolAuth: ["2"],
          },
        },
        {
          path: "/tutorials",
          name: "tutorials",
          component: tutorials,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        {
          path: "/improvement",
          name: "improvement",
          component: improvement,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        {
          path: "/settings-account/:section?/:type?",
          name: "settings-account",
          component: SettingsAccount,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6", "7", "8"],
            title: i18n.t("lang.label.settings"),
          },
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getAll").then(() => {
              next();
            });
          },
        },
        {
          path: "/campaigns-health",
          name: "campaign-problems",
          component: CampaignProblems,
          meta: {
            rolAuth: ["1"],
            title: "Campaigns Health",
          },
        },
        {
          path: "/admin-system-chat",
          name: "admin-system-chat",
          component: AdminSystemChat,
          meta: {
            rolAuth: ["1"],
            title: i18n.t("lang.menu.admin_system_chat"),
          },
        },
        {
          path: "/data-protection-regulation",
          redirect: { path: "/settings-account", query: { rgpd: "1" } },
        },
        {
          path: "/ia-prompts",
          redirect: { path: "/settings-account", query: { IA_PROMPS: "1" } },
        },
        {
          path: "/billing/:id?",
          name: "billing",
          component: Billing,
          meta: {
            rolAuth: ["1", "2"],
          },
        },
        {
          path: "/campaigns/:id?",
          name: "campaigns",
          component: Campaigns,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6", "8"],
            afterTrialPeriodAvailable: false,
            KeepAlive: false, // Need to be cached
            title: i18n.t("lang.menu.campaigns"),
          },
          children: [
            {
              path: "/campaigns/filter/:filter",
              component: Campaigns,
              props: { filter: true },
              meta: {
                rolAuth: ["1", "2", "3", "5", "6", "8"],
                afterTrialPeriodAvailable: false,
                title: i18n.t("lang.menu.campaigns"),
              },
            },
            {
              path: "/campaigns/:id",
              component: CampaignEdit,
              props: { id: true },
              meta: {
                rolAuth: ["1", "2", "3", "5", "6", "8"],
                afterTrialPeriodAvailable: false,
              },
              children: [
                {
                  path: "step1/",
                  name: "editCampaignStep1",
                  component: CampaignEdit,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                    title: i18n.t("lang.menu.campaigns"),
                  },
                },
                {
                  path: "step2/",
                  name: "editCampaignStep2",
                  component: YourAudience,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
                {
                  path: "step3/",
                  name: "editCampaignStep3",
                  component: YourMessage,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
                {
                  path: "step4/",
                  name: "editCampaignStep4",
                  component: Tracking,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
                {
                  path: "step5/",
                  name: "editCampaignStep5",
                  component: Budget,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
                {
                  path: "step6/",
                  name: "editCampaignStep6",
                  component: Summary,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
                {
                  path: "step7/",
                  name: "editCampaignStep7",
                  component: Connection,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
                {
                  path: "step8/",
                  name: "editCampaignStep8",
                  component: Connection,
                  meta: {
                    rolAuth: ["1", "2", "3", "5", "6"],
                    afterTrialPeriodAvailable: false,
                  },
                },
              ],
            },
            {
              path: "/campaigns/:id/copy",
              name: "copyCampaign",
              component: CampaignEdit,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "/campaigns/:id/stats",
              component: CampaignDashboard,
              props: { id: true },
              meta: {
                rolAuth: ["1", "2", "3", "5", "6", "8"],
                afterTrialPeriodAvailable: false,
                KeepAlive: false, // Need to be cached
              },
            },
            {
              path: "step1/",
              name: "campaignStep1",
              component: CampaignEdit,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step2/",
              name: "campaignStep2",
              component: YourAudience,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step3/",
              name: "campaignStep3",
              component: YourMessage,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step4/",
              name: "campaignStep4",
              component: Tracking,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step5/",
              name: "campaignStep5",
              component: Budget,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step6/",
              name: "campaignStep6",
              component: Summary,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step7/",
              name: "campaignStep7",
              component: Connection,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
            {
              path: "step8/",
              name: "campaignStep8",
              component: Connection,
              meta: {
                rolAuth: ["1", "2", "3", "5", "6"],
                afterTrialPeriodAvailable: false,
              },
            },
          ],
        },
        {
          path: "/reports/campaigns/monthly/last",
          name: "monthlyReport",
          component: MonthlyReport,
          meta: {
            rolAuth: ["1", "2", "3"],
          },
        },
        {
          path: "/usages/:id?",
          name: "usages",
          component: Usages,
          meta: {
            rolAuth: ["1", "5", "7"],
            restrictConstraint2: true,
          },
        },
        {
          path: "/invoices_recovering",
          name: "invoices_recovering",
          component: InvoicesRecovering,
          meta: {
            rolAuth: ["1", "5", "7"],
          },
        },
        {
          path: "/payment-methods-client",
          name: "payment-methods-client",
          component: PaymentMethodsList,
          meta: {
            rolAuth: ["1"],
          },
        },
        {
          path: "/credit-notes",
          name: "credit-notes",
          component: CreditNoteList,
          meta: {
            rolAuth: ["1"],
          },
        },
        {
          path: "/invoices_admin",
          name: "invoices_admin",
          component: Invoices,
          meta: {
            rolAuth: ["1"],
          },
        },
        {
          path: "/onboarding",
          name: "onboarding",
          component: Onboarding,
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getAll").then(() => {
              next();
            });
          },
          meta: {
            rolAuth: ["1", "3", "4"],
            afterTrialPeriodAvailable: false,
            KeepAlive: false, // Need to be cached
          },
        },
        {
          path: "/onboarding/:step/:substep",
          name: "onboarding",
          component: Onboarding,
          beforeEnter: (to, from, next) => {
            store.dispatch("optionsList/getAll").then(() => {
              next();
            });
          },
          meta: {
            rolAuth: ["1", "4"],
            afterTrialPeriodAvailable: false,
            KeepAlive: true, // Need to be cached
          },
        },
        {
          path: "/orderlist",
          name: "orders",
          component: Orders,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6"],
            afterTrialPeriodAvailable: true,
            KeepAlive: true, // Need to be cached
          },
        },
        {
          path: "/orderlist/:tab1",
          name: "orders",
          component: Orders,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6"],
            afterTrialPeriodAvailable: true,
            KeepAlive: true, // Need to be cached
          },
        },
        {
          path: "/orders",
          name: "orders",
          component: Orders,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6"],
            afterTrialPeriodAvailable: true,
            KeepAlive: true, // Need to be cached
          },
          beforeEnter: (to, from, next) => {
            Promise.all([
              store.dispatch("optionsList/getJobsGroup"),
              store.dispatch("optionsList/getAll"), // Segunda acción de dispatch
            ])
              .then(() => {
                next(); // Procede a la siguiente ruta
              })
              .catch((error) => {
                console.error("Error during beforeEnter:", error);
                next(false); // Detiene la navegación en caso de error
              });
          },
        },
        {
          path: "/orders-by-lang/:id",
          name: "orders",
          component: Orders,
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6"],
            afterTrialPeriodAvailable: true,
            KeepAlive: true, // Need to be cached
          },
          beforeEnter: (to, from, next) => {
            Promise.all([
              store.dispatch("optionsList/getJobsGroup"),
              store.dispatch("optionsList/getAll"), // Segunda acción de dispatch
            ])
              .then(() => {
                next(); // Procede a la siguiente ruta
              })
              .catch((error) => {
                console.error("Error during beforeEnter:", error);
                next(false); // Detiene la navegación en caso de error
              });
          },
        },
        {
          path: "/orders/:id",
          component: Order,
          props: { id: true },
          meta: {
            rolAuth: ["1", "2", "3", "4", "5", "6"],
            KeepAlive: true, // Need to be cached
          },
          beforeEnter: (to, from, next) => {
            Promise.all([
              store.dispatch("optionsList/getJobsGroup"),
              store.dispatch("optionsList/getAll"), // Segunda acción de dispatch
            ])
              .then(() => {
                next(); // Procede a la siguiente ruta
              })
              .catch((error) => {
                console.error("Error during beforeEnter:", error);
                next(false); // Detiene la navegación en caso de error
              });
            // store.dispatch('optionsList/getAll').then(() => {
            //   next()
            // })
          },
        },
        {
          path: "/orders/add",
          component: Order,
          props: { id: true },
          meta: {
            rolAuth: ["1", "2", "3", "4"],
            afterTrialPeriodAvailable: true,
          },
        },
        {
          path: "/promotion",
          component: Promotion,
          meta: {
            rolAuth: ["1", "2", "3", "4"],
          },
        },
      ],
    },
    // otherwise redirect to opportunities
    { path: "*", redirect: "/opportunities" },
  ],
});

router.beforeEach(async (to, from, next) => {
  // maintenance mode | modo mantenimiento
  // window.location.href = "https://oliverlist.com/in-maintenance";

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    "/login",
    "/createaccount",
    "/createaccount/*",
    "/bookerregistration",
    "/lostpassword",
    "/proposal",
    "/nylas",
    "/client-service-proposal",
    "/testing-new-temporal-proposal",
    "/client-service-proposal-action/*",
  ];

  //const loggedIn = localStorage.getItem("user");
  var anonymousAuth = 0;
  for (var i = publicPages.length - 1; i >= 0; i--) {
    if (to.path.match(publicPages[i])) {
      anonymousAuth = anonymousAuth + 1;
    }
  }

  const authRequired =
    anonymousAuth == 0 &&
    !to.path.includes("/mycalendar") &&
    !to.path.includes("/payment");

  if (store.state.authentication.toastNotificationData == undefined) {
    store.dispatch("authentication/logout");
  }

  const loggedIn = store.state.authentication.user;

  const subscriptionActive =
    store.state.authentication.toastNotificationData.subscriptionActive;
  const isAppAvailable = true; //store.state.authentication.isAppAvailable;
  const dontChargePayments =
    store.state.authentication.toastNotificationData.dontChargePayments;
  const hasDefaultPaymentMethod =
    store.state.authentication.toastNotificationData.hasDefaultPaymentMethod ===
    undefined
      ? false
      : store.state.authentication.toastNotificationData.hasDefaultPaymentMethod
          .length > 0;
  const hasDeclinedPayments =
    store.state.authentication.toastNotificationData.hasDeclinedPayments ===
    undefined
      ? false
      : store.state.authentication.toastNotificationData.hasDeclinedPayments
          .length > 0;
  const trialPeriodEnded =
    store.state.authentication.toastNotificationData.trialPeriodData ===
    undefined
      ? 0
      : store.state.authentication.toastNotificationData.trialPeriodData
          .trial_period_ended;
  const isEmailSync =
    store.state.authentication.isEmailSync === undefined
      ? false
      : store.state.authentication.isEmailSync;

  await store.dispatch("optionsList/getOptions", ["countries"]);

  //var loggedIn = JSON.parse(loggedIn);
  // console.log('loggedIn', loggedIn)
  // console.log('isAppAvailable*', isAppAvailable)
  // console.log('to.meta.rolAut', to.meta.rolAuth)
  // console.log('to.path', to.path);
  // console.log('to.fullPath', to.fullPath);
  // console.log('dontChargePayments', dontChargePayments);
  // console.log('subscriptionActive', subscriptionActive);
  // console.log('store.state.authentication', store.state.authentication);

  if (to.fullPath.includes("/orders") && to.params.id) {
    // console.log('The id is: ' + to.params.id);
    // console.log('es', to.fullPath.includes('/orders/:id'))
    store.dispatch("optionsList/getAll");
  }

  if (authRequired) {
    // TODO: temp disabled
    if (
      loggedIn &&
      loggedIn.role_id == 4 &&
      ((process.env.VUE_APP_ENV == "production" &&
        loggedIn.client_id >= 2855) ||
        process.env.VUE_APP_ENV != "production") &&
      !to.fullPath.includes("/onboarding") &&
      loggedIn.order_created != 1 &&
      !to.fullPath.includes("/settings-account") &&
      !to.fullPath.includes("/downgrade")
    ) {
      if (
        to.fullPath.includes("conditionPayment=error") ||
        to.fullPath.includes("conditionPayment=ok")
      ) {
        const conditionPayment = to.fullPath.includes("conditionPayment=error")
          ? "error"
          : "ok";
        return next({ path: "/onboarding", query: { conditionPayment } });
      } else {
        return next("/onboarding");
      }
    }
    if (
      loggedIn &&
      loggedIn.agency_signed == 1 &&
      loggedIn.agency_signed == 1 &&
      !to.fullPath.includes("/onboarding")
    ) {
      //return next("/onboarding");
    }

    if (
      loggedIn &&
      loggedIn.role_id == 3 &&
      to.fullPath == "/" &&
      !to.fullPath.includes("/opportunities")
    ) {
      return next("/client-space");
    }

    // Restricción para role_id == 1 en móvil - solo permite acceso a /dashboard/tabs/21
    if (
      loggedIn &&
      loggedIn.role_id == 1 &&
      window.innerWidth <= 992 &&
      !to.fullPath.includes("/dashboard/tabs/21") &&
      !to.fullPath.includes("/admin-system-chat")
    ) {
     // return next("/dashboard/tabs/21");
    }

    if (loggedIn && loggedIn.user_constraint_id == 2) {
      const blocked = to.matched.some(
        (record) => record.meta && record.meta.restrictConstraint2 === true
      );

      if (blocked) {
        return next("/dashboard/tabs/1");
        // o next(false) si querés que no navegue
      }
    }
    // If is BDR
    if (
      loggedIn &&
      loggedIn.team_role_id == 2 &&
      loggedIn.role_id == 2 &&
      !to.fullPath.includes("/booker-onboarding") &&
      to.fullPath == "/"
    ) {
      // if(loggedIn.booker && loggedIn.booker.status == "Screening") {
      //   return next("/merci-hubert");
      // } else {
      //   return next("/booker-onboarding");
      // }
      if (loggedIn.booker) {
        const bookerStatus = loggedIn.booker.status;

        switch (bookerStatus) {
          case "Screening":
            return next("/merci-hubert");
          case "Onboarding":
            return next("/booker-onboarding");
          case "Rejected (interview)":
            return next("/merci-hubert");
          case "Rejected (trial)":
            return next("/merci-hubert");
          case "Outdated":
            return next("/merci-hubert");
          case "Stopped":
            return next("/merci-hubert");
          default:
            return next("/booker-onboarding");
        }
      }
    }

    if (loggedIn && loggedIn.role_id == 7 && to.fullPath == "/") {
      return next("/Affiliation");
    }

    if (
      loggedIn &&
      loggedIn.role_id == 2 &&
      to.fullPath == "/" &&
      !to.fullPath.includes("/dashboard")
    ) {
      return next("/dashboard/tabs/1");
    }

    //Si el user es de tipo "Contable": rol_id = 1 y user_constraint_id = 4 (Contable) se le redirige a usages
    const urlValidForAccountant = ["/usages", "/settings-account"];

    if (
      loggedIn &&
      loggedIn.user_constraint_id == 4 &&
      loggedIn.role_id == 1 &&
      !urlValidForAccountant.some((path) => to.fullPath.includes(path))
    ) {
      return next("/usages");
    }

    //Si el user es de tipo "Attendance": rol_id = 1 y user_constraint_id = 7 (Attendance) se le redirige a /meeting-attendance
    const urlValidForAttendance = [
      "/meeting-attendance",
      "/settings-account",
      "/attendance-stats",
      "/meetings-status-processed",
    ];
    if (
      loggedIn &&
      loggedIn.user_constraint_id == 7 &&
      loggedIn.role_id == 1 &&
      !urlValidForAttendance.some((path) => to.fullPath.includes(path))
    ) {
      return next("/meeting-attendance");
    }

    //Si el user es de tipo "Booker recruiter": rol_id = 1 y user_constraint_id = 5 (Booker recruiter) se le redirige a usages
    const urlValidForBookerRecruiter = [
      "/allbdr",
      "/settings-account",
      "/opportunities",
      "/clients",
      "/users",
      "/orders",
      "/dashboard/tabs/21",
    ];

    if (
      loggedIn &&
      loggedIn.user_constraint_id == 5 &&
      loggedIn.role_id == 1 &&
      !urlValidForBookerRecruiter.some((path) => to.fullPath.includes(path))
    ) {
      return next("/allbdr/5");
    }

    if (
      loggedIn &&
      loggedIn.role_id == 4 &&
      loggedIn.agency_signed == 1 &&
      !to.fullPath.includes("/dashboardfirst") &&
      to.fullPath == "/"
    ) {
      return next("/client-space");
    }

    if (
      loggedIn &&
      loggedIn.user_constraint_id == 1 &&
      loggedIn.role_id == 1 &&
      !to.fullPath.includes("/clients") &&
      to.fullPath == "/"
    ) {
      return next("/dashboard/tabs/3");
    }

    if (
      loggedIn &&
      loggedIn.user_constraint_id == 6 &&
      loggedIn.role_id == 1 &&
      !to.fullPath.includes("/clients") &&
      to.fullPath == "/"
    ) {
      return next("/settings-account");
    }

    if (
      loggedIn &&
      loggedIn.user_constraint_id == 2 &&
      loggedIn.role_id == 1 &&
      !to.fullPath.includes("/oliver_sales_stats") &&
      to.fullPath == "/"
    ) {
      return next("/oliver_sales_stats");
    }

    // Redirección para role_id 1 en dispositivo móvil
    if (
      loggedIn &&
      loggedIn.role_id == 1 &&
      to.fullPath == "/" &&
      window.innerWidth <= 992
    ) {
      return next("/dashboard/tabs/21");
    }

    if (
      loggedIn &&
      loggedIn.role_id == 1 &&
      !to.fullPath.includes("/dashboard") &&
      to.fullPath == "/"
    ) {
      return next("/dashboard/tabs/1");
    }

    if (
      loggedIn &&
      loggedIn.role_id == 9 &&
      !to.fullPath.includes("/dashboard") &&
      to.fullPath == "/"
    ) {
      return next("/allbdr/1");
    }

    // ahora los clients con status pending_payment pueden acceder a toda la app sin restriccion 14/02/2024
    // if (
    //   loggedIn &&
    //   hasDeclinedPayments &&
    //   loggedIn.role_id > 1 &&
    //   (loggedIn.is_agency == 0 ||
    //     (loggedIn.is_agency == 1 && loggedIn.role_id == 4))
    // ) {
    //   if (
    //     !to.fullPath.includes('/settings-account') &&
    //     !to.fullPath.includes('/dashboard')
    //   ) {
    //     return next('/settings-account')
    //   }
    // }

    store.state.sidebar.isExpandedList = false;
    if (
      !loggedIn ||
      (loggedIn.role_id > 1 && loggedIn.plan_id === undefined) ||
      loggedIn.is_agency === undefined
    ) {
      if (from.fullPath !== "login") {
        localStorage.setItem("afterLoginGoTo", to.fullPath);
        // return next({ path: "/login", query: { redirect: to.fullPath } })
      }
      return next("/login");
    }

    if (loggedIn.subscription_status_id == 2) {
      if (to.fullPath == "/deleted") {
        return next();
      } else {
        return next("/deleted");
      }
    }

    if (loggedIn && loggedIn.role_id != 1) {
      if (loggedIn.verificationcode != null || loggedIn.client_id == null) {
        return next("/createaccount");
      }
    }

    if (
      process.env.VUE_APP_ENV == "production" &&
      loggedIn.client_id < 2855 &&
      loggedIn.role_id == 4 &&
      parseInt(loggedIn.is_agency) == 1 &&
      parseInt(loggedIn.agency_signed) == 0
    ) {
      if (
        to.fullPath == "/contract" ||
        to.fullPath == "/agencies/me" ||
        to.fullPath.includes("/settings-account/payment")
      ) {
        return next();
      } else {
        return next("/contract");
      }
    }

    // TODO: temp disabled
    //  if (["3", "4"].includes(loggedIn.role_id) && loggedIn.agency_signed == 1 && loggedIn.is_sales == 1
    //   && ((process.env.VUE_APP_ENV == 'production' && loggedIn.client_id >= 2855) || process.env.VUE_APP_ENV != 'production')
    //   && loggedIn.is_agency == 1 && !isEmailSync && !to.fullPath.includes('/settings-account')) {
    //    return next("/settings-account?synchronisation=1");
    //  }

    // ROLE ACCESS
    if (
      !to.fullPath.includes("/dashboard") &&
      $.inArray(loggedIn.role_id, to.meta.rolAuth) == -1
    ) {
      return next("/dashboard/tabs/1");
    }

    //NO PONER NADA A PARTIR DE ACA ABAJO O PROQUE LA AVRIABLE dontChargePayments ARRUINA TODO

    if (dontChargePayments == 1) {
      return next();
    }

    let afterLoginGoTo = localStorage.getItem("afterLoginGoTo");
    if (
      afterLoginGoTo !== undefined &&
      afterLoginGoTo !== to.fullPath &&
      afterLoginGoTo !== "/login"
    ) {
      localStorage.removeItem("afterLoginGoTo");
      return next({ path: afterLoginGoTo, query: null });
    }

    if (
      !isAppAvailable &&
      to.fullPath != "/upgrade" &&
      !to.fullPath.includes("/settings-account?billing=1&payment=1") &&
      to.fullPath != "/settings-account" &&
      !to.fullPath.includes("/settings-account/payment/")
    ) {
      // esta suscrito pero el plan no esta activo porque el metodo de pago por defecto ha fallado por mas de 1 mes
      if (loggedIn.plan_version_id != 0 && subscriptionActive == 0) {
        // console.log('go to settings 1')
        return next("/settings-account?billing=1&payment=1");
      }
      // si tiene metodo de pago y no esta suscrito o no tiene metodo de pago y no esta suscrito
      else if (
        hasDefaultPaymentMethod ||
        (!hasDefaultPaymentMethod && loggedIn.plan_version_id == 0)
      ) {
        // console.log('go to upgrade')
        return next("/upgrade");
      } else {
        // console.log('go to settings 2')
        return next("/settings-account?billing=1&payment=1");
      }
    } else if (
      !isAppAvailable &&
      (to.fullPath == "/upgrade" ||
        to.fullPath.includes("/settings-account?billing=1&payment=1") ||
        to.fullPath.includes("/settings-account/payment/"))
    ) {
      return next();
    }

    // PLAN ID ACCESS
    if (
      loggedIn.role_id != 1 &&
      to.meta.planIdAccess != undefined &&
      $.inArray(loggedIn.plan_id, to.meta.planIdAccess) == -1
    ) {
      return next("/dashboard/tabs/1");
    }

    if (
      loggedIn.subscription_status_id != 1 &&
      trialPeriodEnded == 0 &&
      to.meta.trialPeriodAvailable != undefined &&
      to.meta.trialPeriodAvailable == false
    ) {
      return next("/upgrade");
    }

    if (
      loggedIn.subscription_status_id != 1 &&
      trialPeriodEnded == 1 &&
      to.meta.afterTrialPeriodAvailable != undefined &&
      to.meta.afterTrialPeriodAvailable == false
    ) {
      if (hasDeclinedPayments) {
        if (to.fullPath.includes("/settings-account?billing=1&payment=1")) {
          return next();
        }
        return next("/settings-account?billing=1&payment=1");
      }
      return next("/upgrade");
    }
  }
  if (loggedIn) {
    i18n.locale = loggedIn.lang_code;
  }

  next();
});

// Actualizar el título de la página dinámicamente
router.beforeEach((to, from, next) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = to.meta.title;
    } else {
      document.title = "Oliverlist";
    }

    next();
  });
});

router.afterEach((to, from) => {
  //const loggedIn = localStorage.getItem("user");
  //var user = JSON.parse(loggedIn);
  var user = store.state.authentication.user;

  if (user && process.env.VUE_APP_ENV == "production") {
    if (to.fullPath == "/login") {
    } else {
      let method;
      if (from.fullPath == "/login") {
        method = "boot";
      } else {
        method = "update";
      }
    }
  }
});
